/**
 * ISO 2-letter country codes for embargoed countries that require
 * DUNS number or document upload during early (GDK) enrollment.
 */
export const embargoedCountryCodes = new Set<string>([
  "AF", // Afghanistan
  "AM", // Armenia
  "AZ", // Azerbaijan
  "BD", // Bangladesh
  "BY", // Belarus
  "BR", // Brazil
  "KH", // Cambodia
  "CF", // Central African Republic
  "CY", // Cyprus
  "CN", // China
  "CD", // Democratic Republic of Congo
  "ER", // Eritrea
  "ET", // Ethiopia
  "GE", // Georgia
  "HT", // Haiti
  "HK", // Hong Kong
  "HU", // Hungary
  "IN", // India
  "IQ", // Iraq
  "KZ", // Kazakhstan
  "KG", // Kyrgyzstan
  "LB", // Lebanon
  "LY", // Libya
  "MO", // Macau
  "MV", // Maldives
  "ML", // Mali
  "MX", // Mexico
  "MD", // Moldova
  "MM", // Myanmar
  "NI", // Nicaragua
  "PK", // Pakistan
  "PL", // Poland
  "RU", // Russia
  "SA", // Saudi Arabia
  "RS", // Serbia
  "SG", // Singapore
  "SO", // Somalia
  "ZA", // South Africa
  "SS", // South Sudan
  "SD", // Sudan
  "TJ", // Tajikistan
  "TR", // Turkey
  "UA", // Ukraine
  "AE", // United Arab Emirates
  "UZ", // Uzbekistan
  "VE", // Venezuela
  "YE", // Yemen
]);
